class TopbarTimer extends HTMLElement {
  constructor() {
    super();
    this.duration = parseInt(this.dataset.timer) * 3600000;
    this.blocks = {
      h: this.querySelector(".new-top-bar-timer-block-hours"),
      m: this.querySelector(".new-top-bar-timer-block-mins"),
      s: this.querySelector(".new-top-bar-timer-block-secs")
    };
    this.cookieName = this.dataset.name;
    this.start();
  }

  start() {
    let startTime = this.getStartTime();
    const update = () => {
      let elapsed = Date.now() - startTime;
      let remaining = this.duration - elapsed;
      if (remaining <= 0) {
        startTime = Date.now();
        this.setCookie(startTime);
        remaining = this.duration;
      }
      const h = String(Math.floor(remaining / 3600000)).padStart(2, "0");
      const m = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, "0");
      const s = String(Math.floor((remaining % 60000) / 1000)).padStart(2, "0");
      this.blocks.h.textContent = h;
      this.blocks.m.textContent = m;
      this.blocks.s.textContent = s;
    };
    update();
    setInterval(update, 1000);
  }

  getStartTime() {
    const cookie = document.cookie.split("; ").find(c => c.startsWith(this.cookieName + "="));
    const stored = cookie ? parseInt(cookie.split("=")[1]) : NaN;
    const now = Date.now();
    if (!stored || isNaN(stored) || now - stored >= this.duration) {
      this.setCookie(now);
      return now;
    }
    return stored;
  }
  setCookie(time) {
    document.cookie = `${this.cookieName}=${time}; path=/; max-age=31536000`; // 1 year
  }
}

customElements.define('topbar-timer', TopbarTimer);

class NewHeroTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".new-hero-tab-li");
    this.content = this.querySelectorAll(".new-hero-tab-content");
    this.init();
  }

  init() {
    let $this = this;
    this.tabs.forEach(function(item){
      item.addEventListener("click", function(e){
        $this.tabs.forEach(function(item){
          item.classList.remove("active");
        })
        e.currentTarget.classList.add("active");
        let title = e.currentTarget.dataset.title;
        $this.content.forEach(function(item){
          item.classList.remove("active");
          item.classList.remove("active--tab");
        })
        $this.content.forEach(function(item){
          if(item.dataset.title == title){
            item.classList.add("active");
            setTimeout(function(){
              item.classList.add("active--tab");
            },10)
          }
        })
      })
    })
  }
}

customElements.define('new-hero-tabs', NewHeroTabs);

$(".new-iwt-faq-title").click(function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next(".new-iwt-faq-text").slideToggle(300);
  }
  else{
    $(this).parents(".new-iwt-faq-wrapper").find(".new-iwt-faq-title").removeClass("active");
    $(this).parents(".new-iwt-faq-wrapper").find(".new-iwt-faq-text").slideUp(300);
    $(this).addClass("active");
    $(this).next(".new-iwt-faq-text").slideDown(300);
  }
})